<template>
  <div id="header">
    <div id="header-inner">
      <router-link to="home">
        <logo />
      </router-link>
      <navigation :basic="basic" />
    </div>
  </div>
</template>

<script>
import {db} from '../firebase'

import Logo from './Logo.vue'
import Navigation from './Navigation.vue'

export default {
  name: 'home',
  data () {
    return {
      basic: Array
    }
  },
  firebase: {
    basic: {
      source: db.ref('basic'),
      cancelCallback (err) {
        console.error(err)
      }
    },
    work: {
      source: db.ref('projects').orderByChild('weight'),
      cancelCallback (err) {
        console.error(err)
      }
    },
    bio: {
      source: db.ref('bio'),
      cancelCallback (err) {
        console.error(err)
      }
    },
    stills: {
      source: db.ref('stills').orderByChild('weight'),
      cancelCallback (err) {
        console.error(err)
      }
    }
  },
  components: {
    Logo,
    Navigation
  }
}
</script>

<style scoped>
.loading #header {
  top: -100%;
  transition-property: top;
  transition-duration: 0.75s;
  transition-delay: 0.5s;
  transition-timing-function: ease;
}

#header {
  transition-property: top;
  transition-duration: 0.75s;
  transition-delay: 0.5s;
  transition-timing-function: ease;
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  z-index: 10;
}

#header-inner {
  position: relative;
}
</style>



// WEBPACK FOOTER //
// Heading.vue?d37ba64e